export function formatExperienceYears(
  experience: number | string | null | undefined
): string {
  if (experience == null) return "-";
  if (typeof experience === "string" && experience.trim() === "") return "-";

  const years = Number(experience);
  if (!Number.isFinite(years) || years <= 0) return "-";

  return `${years}년`;
}
